import Button from 'react-bootstrap/Button';
import api from '../../app/api';

const SaveBlock = (props) => {

  const doSave = async () => {
    props.setLoading(true);
    try {
      const postResponse = await api.post('/api/profiles/data',
        {
          selectedProfile: {id:props.profile.id, name:props.profile.name, yearCalc: props.profile.yearCalc},
          income: props.income.records,
          expenses: props.expenses.records,
          debt: props.debt,
          descriptions: [...props.income.descriptions, ...props.expenses.descriptions, ...props.debt.descriptions],
          profiles: []
        }
      )
      if (postResponse.status === 200) {
        props.save(postResponse.data);
      } else {
        props.setErrorShow(true);
        props.setErrorTitle("Profile Save Failed");
        props.setErrorMessage("An error occurred while saving the profile. Please try again.");
      }
      props.setLoading(false);
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        console.error('Save failed:', error.response?.status);
        props.setErrorTitle("Your session has expired");
        props.setErrorMessage("Your session has expired, please log in again.");
        props.setErrorShow(true);
        props.setLoading(false);
        props.handleLogOut();
      } else {
        console.error('Save failed:', error.response?.status);
        props.setErrorTitle("Profile Save Failed");
        props.setErrorMessage("An error occurred while saving the profile. Please try again.");
        props.setErrorShow(true);
        props.setLoading(false);
      }
    }
  }

  return (
    <div className="save-block" role="group" aria-label="Profile actions">
      <Button variant="primary" onClick={() => {
        doSave()
      }}>Save</Button>
      <Button variant="outline-primary" onClick={() => {
        props.fetchProfile(props.profile.id);
      }}>Reload last save</Button>
    </div>
  );
}

export default SaveBlock;